import React from 'react'
import './contact.scss'
import img from '../contact.png'
function Contact() {
  const email = "info@test.de";
  const tel = "015114766666";
  
  return (
    <div className='contact_container'>
    <div className='contact '>
      <h1>Kontakt</h1>
        <img src={img} alt="" />
        <span>
        <a href={`tel:${tel}`}  className="phone">
        Telefonnummer: {tel}
        
          <box-icon type='solid' name='phone'></box-icon>
          </a>
        </span>
      
        {/* <span>
        <a href={`mailto:${email}`} className="email">
        E-Mail: {email}
          <box-icon name='envelope' type='solid' ></box-icon>
          </a>
        </span> */}
    </div>
     
       
    </div>
  )
}

export default Contact